<template>
  <div class="message-detail-panel__member-wrap">
    <div
      class="message-detail-panel__member"
      @contextmenu="onContextmenu"
    >
      <z-avatar
        :size="28"
        :style="{ backgroundColor: memberAvatarColor(member.id) }"
      >
        {{ memberInitial(member.name) }}
      </z-avatar>
      <span class="message-detail-panel__member-name">{{ member.name }}</span>
    </div>
    <z-dropdown
      ref="dropdownRef"
      class="message-detail-panel__member-menu"
      :virtual-ref="triggerRef"
      virtual-triggering
      trigger="click"
      placement="bottom-start"
      :show-arrow="false"
      :popper-options="popperOptions"
      popper-class="message-member-popper"
      @command="onCommand"
    >
      <template #dropdown>
        <z-dropdown-menu>
          <z-dropdown-item command="direct" :disabled="!canDirect">
            发送消息
          </z-dropdown-item>
          <z-dropdown-item command="profile">查看资料</z-dropdown-item>
          <z-dropdown-item command="mention">@{{ member.name }}</z-dropdown-item>
          <z-dropdown-item
            divided
            command="copy-account"
            :disabled="!member.username"
          >
            复制账号
          </z-dropdown-item>
          <z-dropdown-item command="copy-email" :disabled="!member.email">
            复制邮箱地址
          </z-dropdown-item>
        </z-dropdown-menu>
      </template>
    </z-dropdown>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from 'vue'
import ZAvatar from '@zoryn/components/avatar'
import ZDropdown, {
  ZDropdownItem,
  ZDropdownMenu,
} from '@zoryn/components/dropdown'
import type { DropdownInstance } from '@zoryn/components/dropdown'
import {
  canDirectChat,
  memberAvatarColor,
  memberInitial,
} from '../utils/conversation-utils'
import {
  closeExclusiveConversationMenu,
  openExclusiveConversationMenu,
} from '../utils/conversation-menu'
import type {
  ConversationMember,
  GroupMemberMenuCommand,
} from '../types'
import '@zoryn/components/avatar/style'
import '@zoryn/components/dropdown/style'

const props = defineProps<{
  member: ConversationMember
}>()

const emit = defineEmits<{
  command: [command: GroupMemberMenuCommand, member: ConversationMember]
}>()

const canDirect = computed(() => canDirectChat(props.member))

function cursorRect(x: number, y: number): DOMRect {
  return {
    x,
    y,
    width: 0,
    height: 0,
    top: y,
    left: x,
    right: x,
    bottom: y,
    toJSON: () => ({}),
  } as DOMRect
}

const dropdownRef = ref<DropdownInstance>()
const position = ref(cursorRect(0, 0))
const triggerRef = ref({
  getBoundingClientRect: () => position.value,
})
const popperOptions = {
  modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
}

function closeMenu() {
  dropdownRef.value?.handleClose()
}

function onContextmenu(event: MouseEvent) {
  event.preventDefault()
  event.stopPropagation()
  position.value = cursorRect(event.clientX, event.clientY)
  openExclusiveConversationMenu(
    `member:${props.member.id}`,
    () => dropdownRef.value?.handleOpen(),
    closeMenu
  )
}

function onCommand(command: string | number | object) {
  emit('command', command as GroupMemberMenuCommand, props.member)
}

onBeforeUnmount(() => {
  closeExclusiveConversationMenu(`member:${props.member.id}`)
})
</script>
